export const TITLES: Record<string, string> = {
  g2d: "2D Perf",
  dx9: "DX9",
  dx10: "DX10",
  dx11: "DX11",
  dx12: "DX12",
  overallSpeed: "Speed",
  pricePerG3D: "3D/Price",
};

export const COMPARISON_KEYS = [
  "g2d",
  "dx9",
  "dx10",
  "dx11",
  "dx12",
  "overallSpeed",
];
